<aside class="premium-state__container"
        [class.premium-state__container--active]="isPremiumActive()"
        [class.premium-state__container--expired]="isLicenceExpired()">
    @if (isPremiumActive()) {
        <div class="premium-state__label">
            {{ 'toolbar.premium_state_demo_active' | translate }}
        </div>
        <p class="premium-state__expiration-date"
            [innerHTML]="'toolbar.premium_state_demo_expires_at' | translate:{date: '<strong>'+localeDate()+'<\/strong>'}">
        </p>
        @if (shouldShowExtendButton()) {
            <button class="premium-state__extend-button"
                    (click)="expandPremiumClick($event)">
                {{ 'toolbar.premium_state_expand' | translate }}
            </button>
        }
    } @else if (isLicenceExpired()) {
        <div class="premium-state__label">
            {{ 'toolbar.premium_state_licence_expired' | translate }}
        </div>
    }
</aside>
